(function($) {   

  const mailsvg =`<svg 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg" 
      x="0px" 
      y="0px"
      width="24px" 
      height="24px" 
      viewBox="0 0 24 24"
    >
    <g transform="translate(-231.54,-375.82)">
      <ellipse cx="243.54" cy="387.82" rx="9.832" ry="9.832"/>
      <g transform="matrix(3.8189326,0,0,3.8189326,-1398.1391,-1597.4564)">
        <g transform="translate(-560.19,271.89)">
          <path fill="#FFFFFF" d="M988.624,246.82c-0.07,0-0.129,0.058-0.129,0.128v2.023c0,0.071,0.058,0.129,0.129,0.129h2.891
            c0.071,0,0.129-0.058,0.129-0.129v-2.023c0-0.07-0.058-0.128-0.129-0.128H988.624z M988.967,247.128h2.205l-1.103,0.963
            L988.967,247.128z M991.385,247.282v1.424l-0.806-0.718L991.385,247.282z M988.752,247.283l0.81,0.707l-0.81,0.723V247.283z
            M990.385,248.156l0.767,0.684h-2.158l0.763-0.681l0.227,0.2c0.049,0.042,0.12,0.042,0.168,0L990.385,248.156L990.385,248.156z"
            />
        </g>
      </g>
    </g>
  </svg>`
  
  const xsvg =`<svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px"
    width="24px"
    height="24px" 
    viewBox="0 0 24 24" 
    enable-background="new 0 0 24 24" 
    xml:space="preserve"
  >
    <g transform="translate(-231.54,-375.82)">
      <ellipse cx="243.54" cy="387.82" rx="9.832" ry="9.832"/>
      <path fill="#FFFFFF" d="M237.536,381.996h3.853l2.734,3.887l3.32-3.887h1.213l-3.984,4.666l4.914,6.981h-3.852l-3.175-4.509
        l-3.852,4.509h-1.213l4.517-5.288L237.536,381.996z M239.394,382.966l6.846,9.707h1.487l-6.846-9.707H239.394z"/>
    </g>
  </svg>`

  let $widgetsocialicons = $('.WidgetSocialIcons')
  if($widgetsocialicons.length) {

    const $destination = $('#main article .entry-content .wp-block-academy-resources')   
    $widgetsocialicons = $widgetsocialicons.remove() 

    $destination.before($widgetsocialicons)

    const title = $('.entry-title').html()
    const url = location.href

    const $facebook = $widgetsocialicons.find('li.Facebook a')
    $facebook.attr('href', `http://www.facebook.com/sharer.php?u=${url}&t=${title}`)
    
    const $twitter = $widgetsocialicons.find('li.Twitter a')
    $twitter.html(xsvg)
    $twitter.attr('href', `http://twitter.com/share?text=${encodeURI(title)}&url=${encodeURI(url)}`)

    const $mail = $widgetsocialicons.find('li.Mail a')
    $mail.html(mailsvg)
    const message = __('I would like to share this article from')
    $mail.attr('href', `mailto:destinario?subject=${message} ${window.academystatus.sitename}&body=${title}  ${url}`)
    
    $widgetsocialicons.show()
  }

  const $footerfishtwitterlink = $('.FooterFish .wp-block-social-links .wp-social-link-twitter a')
  if($footerfishtwitterlink.length) {
    
    $footerfishtwitterlink.html(xsvg)
  }

  /*
  let $respond = $('#respond')
  if($respond.length) {

    const $destination = $('#main article .entry-content .wp-block-academy-resources')   
    $widgetsocialicons = $widgetsocialicons.remove() 

    $destination.before($widgetsocialicons)
    $widgetsocialicons.show()
  }
  */
})(jQuery)